import React, { Component } from 'react';
import propTypes from 'prop-types';
import Isotope from 'isotope-layout';

import RecordNotes from './RecordNotes';
import ModuleMain from './Modules/ModuleMain';
import ModuleContact from './Modules/ModuleContact';
import ModuleLocation from './Modules/ModuleLocation';
import ModuleSales from './Modules/ModuleSales';
import ModuleHear from './Modules/ModuleHear';
import ModuleOffers from './Modules/ModuleOffers';
import ModuleAbility from './Modules/ModuleAbility';
import ModuleProspect from './Modules/ModuleProspect';

import ModuleVolumeOwed from './Modules/ModuleVolumeOwed';
import VolOwed from './Modules/VolOwed';


export default class RecordView extends Component {

  // Render
  // ----------------------------------------------------
  render() {
    const { index, data } = this.props;
    this.gridLayout()


    return (
      <div className="RecordView" key={this.props.currentId}>
        <div className="ModuleContainer">
          <div className="ModuleList">
            <ModuleMain
              changeRecordHandler={this.props.changeRecordHandler}
              changeSelectBlock={this.props.changeSelectBlock}
              spName={this.props.currentRecord['SP Name']}
              spNumber={this.props.currentRecord['Number']}
              status={this.props.currentRecord['Status']}
              level={this.props.currentRecord['Franchise Level']}
              company={this.props.currentRecord['Company Name']}
              ein={this.props.currentRecord['EIN']}
              volumeDate={this.props.currentRecord['Volume Due Date']}
              language={this.props.currentRecord['Languages']}
              calcVolume={this.props.calcVolume}
              zip={this.props.currentRecord['Zip']}
              area={this.props.currentRecord['Coverage Area']}
              updateCoverageArea={this.props.updateCoverageArea}
            />
            <ModuleContact
              changeRecordHandler={this.props.changeRecordHandler}
              home={this.props.currentRecord['Home Phone']}
              cell={this.props.currentRecord['Cellphone']}
              email={this.props.currentRecord['Email']}
              partner={this.props.currentRecord['Partner Name']}
              partnerPhone={this.props.currentRecord['Partner Phone']}
              english={this.props.currentRecord['English Contact']}
              englishPhone={this.props.currentRecord['English Contact Phone']}
              englishEmail={this.props.currentRecord['English Contact Email']}
              partnerEmail={this.props.currentRecord['Partner Email']}
              newRecord={this.props.newRecord}
            />
            <ModuleSales
              changeRecordHandler={this.props.changeRecordHandler}
              changeSelectBlock={this.props.changeSelectBlock}
              referral={this.props.currentRecord['Referral']}
              packet={this.props.currentRecord['Packet Sent']}
              standing={this.props.currentRecord['Standing']}
              contDate={this.props.currentRecord['Contact Date']}
              veteran={this.props.currentRecord['Veteran']}
              inactiveDate={this.props.currentRecord['Inactive Date']}
              activeDate={this.props.currentRecord['Active Date']}
              apptDate={this.props.currentRecord['Appt. Date']}
              apptTime={this.props.currentRecord['Appt. Time']}
              attended={this.props.currentRecord['Attended']}
              rep={this.props.currentRecord['Sales Rep']}
              repChange={this.props.repChange}
              handleDayClick={this.props.handleDayClick}
              changeCheckHandler={this.props.changeCheckHandler}
              toggleDayPicker={this.props.toggleDayPicker}


              fdd={this.props.currentRecord['FDD Sign Date']}
              sign={this.props.currentRecord['Sign Date']}
              graduation={this.props.currentRecord['Graduation Date']}
              plan={this.props.currentRecord['Plan Type']}
              ar={this.props.currentRecord['Additional Revenue']}
              downPayment={this.props.currentRecord['$ Down']}
            />
            {this.prospectBox}

            <ModuleLocation
              changeRecordHandler={this.props.changeRecordHandler}
              currentRecord={this.props.currentRecord}
              addr1={this.props.currentRecord['Address']}
              city={this.props.currentRecord['City']}
              zip={this.props.currentRecord['Zip']}
              state={this.props.currentRecord['State']}
              county={this.props.currentRecord['County']}
              saveCoords={this.props.saveCoords}
            />

            <ModuleAbility
              perCapacity={this.props.currentRecord['Account Capacity']}
              monthlyCapacity={this.props.currentRecord['Monthly Capacity']}
              looking={this.props.currentRecord['Looking for More']}
              carpets={this.props.currentRecord['Carpets']}
              sWax={this.props.currentRecord['Strip and Wax']}
              buffing={this.props.currentRecord['Buffing']}
              tiles={this.props.currentRecord['Tile']}
              employees={this.props.currentRecord['Employees']}
              specialties={this.props.currentRecord['Account Specialties']}
              daytime={this.props.currentRecord['Daytime']}
              changeRecordHandler={this.props.changeRecordHandler}
              currentRecord={this.props.currentRecord}
              baseId={this.props.baseId}
            />
            <ModuleHear
              changeNotesHandler={this.props.changeNotesHandler}
              changeRecordHandler={this.props.changeRecordHandler}
              source={this.props.currentRecord['Source']}
            />



            {this.offersBox}
            {this.volumeOwedBox}
            {this.volumeHistory}

          </div>
        </div>

        <RecordNotes
          notes={this.props.currentRecord['Notes']}
          changeNotesHandler={this.props.changeNotesHandler}
          controlsModalToggle={this.props.controlsModalToggle} />
      </div>
    );
  }

  get prospectBox() {
    if (this.props.currentRecord['Status'] === 'Prospect' || this.props.currentRecord['Status'] === '') {
      if (!this.props.newRecord) {
        return (
          <ModuleProspect
            currentRecord={this.props.currentRecord}
            addToFollows={this.props.addToFollows}
          />
        );
      } else {
        return;
      }
    }
  }

  get offersBox() {
    if (this.props.currentRecord['Status'] !== 'Prospect' && this.props.currentRecord['Status'] !== '') {
      return (
        <ModuleOffers
          currentRecord={this.props.currentRecord}
        />
      );
    }
  }
  get volumeOwedBox() {
    if (this.props.currentRecord['Status'] !== 'Prospect' && this.props.currentRecord['Status'] !== '') {
      return (
        <ModuleVolumeOwed
          totalRev={this.props.currentRecord['Total Revenue']}
          volOwed={this.props.currentRecord['Owed']}
          rpDue={this.props.currentRecord['RP Due']}
          aaCharge={this.props.currentRecord['Chargeable']}
          changeRecordHandler={this.props.changeRecordHandler}

          updateOwed={this.props.updateOwed}
        />
      );
    }
  }
  get volumeHistory() {
    if (this.props.currentRecord['Status'] !== 'Prospect' && this.props.currentRecord['Status'] !== '') {
      return (
        <VolOwed
          plan={this.props.currentRecord['Plan Type']}
          ar={this.props.currentRecord['Additional Revenue']}
          sign={this.props.currentRecord['Sign Date']}
          currentRecord={this.props.currentRecord}
          baseId={this.props.baseId}
          spName={this.props.currentRecord['SP Name']}

          updateOwed={this.props.updateOwed}
        />
      );
    }
  }

  gridLayout() {
    setTimeout(function(){
      var elem = document.querySelector('.ModuleList');
      var iso = new Isotope( elem, {itemSelector: '.ModuleCard'});
    }, 100);
  }
  gridDestroy() {
    var elem = document.querySelector('.ModuleList');
    var iso = new Isotope( elem, {itemSelector: '.ModuleCard'});
    iso.destroy()
  }
}


RecordView.propTypes ={
  currentId: propTypes.string.isRequired,
  recordChanges: propTypes.bool.isRequired,
  changeNotesHandler: propTypes.func.isRequired,
  changeRecordHandler: propTypes.func.isRequired,
  controlsModalToggle: propTypes.func.isRequired,
  currentRecord: propTypes.object.isRequired,
  recordChanger: propTypes.func.isRequired,
  changeSelectBlock: propTypes.func.isRequired,
  baseId: propTypes.string.isRequired,
  calcVolume: propTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/Franchisees/Records/RecordView.js